<!--维修订单配件询价-->
<template>
  <div class="dialog-content">
    <el-table border="" :fit="true" :data="objectsList" ref="objectsTable">
      <el-table-column show-overflow-tooltip prop="ObjectCode" label="汽配编码" min-width="160px">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.CodeSel"
            value-key="NewGuid"
            filterable
            remote
            :remote-method="(val)=>getAutoPartsListByCode(val,scope.row.AutoSerieId)"
            :loading="selectloading"
            @change="autoPartsByCodeChange($event,scope.row)"
            clearable
            placeholder="请输入编码"
            default-first-option
          >
            <template>
              <div class="optionHeader">
                <span style="margin-left:0;">编号</span>
                <span>类型</span>
                <span>名称</span>
                <span>车型</span>
                <span>历史最高价</span>
              </div>
            </template>
            <el-option
              v-for="item in autoPartsListByCode"
              :key="item.NewGuid"
              :label="item.GoodsCode"
              :value="item"
            >
              <span style="margin-left:0px;">{{ item.GoodsCode }}</span>
              <span>{{ item.Type==2?"手动输入":item.Type==1?"历史商品":"基础配件" }}</span>
              <span>{{ item.GoodsName }}</span>
              <span>{{ item.AutoSerieName }}</span>
              <span>{{ item.HistoryMaxPrice }}</span>
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="ObjectName" label="汽配名称" min-width="150px">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.NameSel"
            value-key="NewGuid"
            filterable
            remote
            :remote-method="(val)=>getAutoPartsListByName(val,scope.row.AutoSerieId)"
            :loading="selectloading"
            @change="autoPartsByNameChange($event,scope.row)"
            clearable
            placeholder="请输入名称"
            default-first-option
          >
            <template>
              <div class="optionHeader">
                <span style="margin-left:0;">编号</span>
                <span>类型</span>
                <span>名称</span>
                <span>车型</span>
                <span>历史最高价</span>
              </div>
            </template>
            <el-option
              v-for="item in autoPartsListByName"
              :key="item.NewGuid"
              :label="item.GoodsName"
              :value="item"
            >
              <span style="margin-left:0px;">{{ item.GoodsCode }}</span>
              <span>{{ item.Type==2?"手动输入":item.Type==1?"历史商品":"基础配件" }}</span>
              <span>{{ item.GoodsName }}</span>
              <span>{{ item.AutoSerieName }}</span>
              <span>{{ item.HistoryMaxPrice }}</span>
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="车型" min-width="150px">
        <template slot-scope="scope">
          <span>{{scope.row.AutoSeries}}</span>
        </template>
      </el-table-column>
      <el-table-column label="数量" prop="Count"></el-table-column>
      <el-table-column show-overflow-tooltip prop="BrandId" label="品牌" min-width="150px">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.BrandSel"
            value-key="Id"
            filterable
            remote
            :remote-method="getBrandsList"
            :loading="selectloading"
            @change="brandChange($event,scope.row)"
            default-first-option
            clearable
            placeholder="请选择品牌"
          >
            <el-option v-for="item in brandsList" :key="item.Id" :label="item.Name" :value="item"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="单位" min-width="150px">
        <template slot-scope="scope">
          <el-select
            v-model.trim="scope.row.Unit"
            placeholder="请选择单位"
            style="width: 100%"
            size="medium"
            filterable
            allow-create
            default-first-option
            clearable
          >
            <el-option v-for="item in Unit" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="备注" min-width="150px">
        <template slot-scope="scope">
          <el-input size="medium" type="text" v-model.trim="scope.row.Remark"/>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align:right;margin-top:20px;">
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog('cancel')">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "inquiryBillObject",
  props: {
    objects: { type: Array, default: () => [] },
    repairOrderId: String,
    entpId: String
  },
  data() {
    return {
      Unit: ["件", "个", "片", "只", "台", "升", "毫升"],
      //objectsList: JSON.parse(JSON.stringify(this.objects)), //阻止修改父级数据
      objectsList: [],
      selectloading: false,
      brandsList: [],
      autoPartsListByName: [],
      autoPartsListByCode: []
    };
  },
  watch: {
    objects: {
      // eslint-disable-next-line no-unused-vars
      handler(newVal, oldVal) {
        let oldObjects = JSON.parse(JSON.stringify(this.objects)); //阻止修改父级数据
        //重构列表数据对象
        oldObjects.forEach(e => {
          this.objectsList.push({
            ObjType: 2, //0基础配件，1历史商品，2未知；在维修单获取到的默认为2，除非客服再次进行选择
            ObjectId: "", //对象类型为未知，所以这里为空
            ObjectCode: e.GoodsCode,
            CodeSel: e.GoodsCode,
            ObjectName: e.GoodsName,
            NameSel: e.GoodsName,
            Count: e.ActualCount,
            Unit: "",
            Remark: "",
            AutoSerieId: e.AutoSerieId,
            AutoSerieName: e.AutoSerieName,
            AutoSeries: e.AutoSeries,
            BrandId: "",
            BrandName: "",
            BrandSel: "",
            RepairOrderProductRsId: e.RsId,
            ObjIdFrom: "unknown" //对象id是从哪里来的，是选中编码对象得到（Code），还是选中名称对象得到（Name），两者都不是为unknow
          });
        });
      },
      immediate: true
    }
  },
  methods: {
    //获取汽配件列表，其实这里是获取报价记录历史与基本配件的数据
    getAutoPartsListByName(searchKey, autoSeriesId) {
      if (!searchKey) {
        return;
      }
      this.selectloading = true;
      let asid = autoSeriesId;
      this.axios
        .get("/ERPGood/GetHistoryGoodsAndAutoPartsList", {
          params: { autoSeriesId: asid, name: searchKey },
          data: {}
        })
        .then(response => {
          let data = response.data.data;
          if (!data) {
            data = [];
          }
          //添加输入值到第一条
          data.unshift({
            Type: 2,
            GoodsId: "",
            GoodsName: searchKey,
            EnName: "",
            GoodsCode: "",
            HistoryMaxPrice: "",
            AutoSerieName: ""
          });
          this.autoPartsListByName = data;
          this.selectloading = false;
        });
    },
    getAutoPartsListByCode(searchKey, autoSeriesId) {
      if (!searchKey) {
        return;
      }
      this.selectloading = true;
      let asid = autoSeriesId;
      this.axios
        .get("/ERPGood/GetHistoryGoodsAndAutoPartsList", {
          params: { autoSeriesId: asid, code: searchKey },
          data: {}
        })
        .then(response => {
          let data = response.data.data;
          if (!data) {
            data = [];
          }
          //添加输入值到第一条
          data.unshift({
            Type: 2,
            GoodsId: "",
            GoodsName: "",
            EnName: "",
            GoodsCode: searchKey,
            HistoryMaxPrice: "",
            AutoSerieName: ""
          });
          this.autoPartsListByCode = data;
          this.selectloading = false;
        });
    },
    autoPartsByCodeChange(sel, row) {
      // 1编码（选）  名称（补全）  id为编码id
      // 2编码（填）  名称（选）    id为名称id
      // 3编码（补全）名称（选）    id为名称id
      // 4编码（为空）名称（填）    id为空
      // 5编码（选）  名称（改）    id编码id

      //汽配编码，obj:选中的编码对象
      //1.填 名称、id不变
      //2.选 名称=obj名称，id=objid
      //3.清 编码='',名称不变，id=''

      //清
      if (sel == null) {
        row.ObjectId = "";
        row.ObjectCode = "";
        row.ObjType = 2;
        row.ObjIdFrom = "unknown";
      } else {
        //填
        if (sel.Type == 2) {
          row.ObjectCode = sel.GoodsCode;
          row.ObjType = sel.Type;
        } else {
          //选
          row.ObjectId = sel.GoodsId;
          row.ObjectName = sel.GoodsName;
          row.NameSel = sel.GoodsName;
          row.ObjectCode = sel.GoodsCode;
          row.ObjType = sel.Type;
          row.ObjIdFrom = "Code";
        }
      }
    },
    autoPartsByNameChange(sel, row) {
      //汽配名称，obj:选中的名称对象
      //1.填 编码不变，if 编码值是由选中的编码对象得到，编码、id不变  else id=''
      //2.选 if 编码值是由选中的编码对象得到，编码、id不变  else if 编码!='' 编码不变，id=objid  else 编码=obj编码，id=objid
      //3.清 名称='',if 编码值是由选中的编码对象得到，id不变 else id=''

      //清
      if (sel == null) {
        row.ObjectName = "";
        row.ObjType = 2;
        if (row.ObjIdFrom != "Code") {
          row.ObjectId = "";
          row.ObjIdFrom = "unknown";
        }
      } else if (sel.Type == 2) {
        //填
        row.ObjectName = sel.GoodsName;
        row.ObjType = sel.Type;
        if (row.ObjIdFrom != "Code") {
          row.ObjectId = "";
          row.ObjIdFrom = "unknown";
        }
      } else {
        //选
        row.ObjectName = sel.GoodsName;
        row.ObjType = sel.Type;

        if (row.ObjIdFrom == "Code") {
          return true;
        } else if (row.ObjectCode) {
          row.ObjectId = sel.GoodsId;
          row.ObjIdFrom = "Name";
        } else {
          row.ObjectId = sel.GoodsId;
          row.ObjectCode = sel.GoodsCode;
          row.CodeSel = sel.GoodsCode;
          row.ObjIdFrom = "Name";
        }
      }
    },
    //获取品牌列表
    getBrandsList(key) {
      if (!key) {
        return;
      }
      this.selectloading = true;
      this.axios
        .get("/ERPGood/GetMallBrands", {
          params: { name: key },
          data: {}
        })
        .then(response => {
          let data = response.data.data;
          if (!data) {
            data = [];
          }
          if (!data.find(x => x.Name == key)) {
            data.unshift({ Id: "", Name: key });
          }

          this.brandsList = data;
          this.selectloading = false;
        });
    },
    brandChange(sel, row) {
      if (sel) {
        row.BrandId = sel.Id;
        row.BrandName = sel.Name;
      } else {
        row.BrandId = "";
        row.BrandName = "";
      }
    },
    submitForm() {
      // --车型、名称、数量、单位  暂时定义这必填，编码、品牌为非必填。
      let objectsList = this.objectsList;
      for (let i = 0; i < objectsList.length; i++) {
        if (
          !objectsList[i].ObjectName ||
          !objectsList[i].Unit ||
          objectsList[i].Count == 0
        ) {
          this.$util.warningMsg("请输入或选中相应的汽配名称、数量、单位");
          return;
        }
      }

      let _formData = {
        Inquirer: this.entpId,
        RepairOrderId: this.repairOrderId,
        BillObjectRsList: objectsList
      };
      this.axios
        .post("/RepairManagement/CreateInquiryBill", _formData)
        .then(res => {
          if (res.data.errcode == 0) {
            this.$util.successMsg("创建成功");
            this.closeDialog("create");
          } else {
            this.$message.error("创建失败！");
          }
        })
        .catch(() => {
          this.$message.error("创建失败！");
        });
    },
    closeDialog(action) {
      this.objectsList = [];
      this.$emit("controlIBDialogVisible", { visible: false, action: action });
    }
  }
};
</script>

<style lang="less" scoped>
.optionHeader {
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
  color: #303133;
  font-weight: bold;
}
.optionHeader span {
  float: left;
  margin-left: 20px;
  //   min-width: 150px;
  width: 200px;
  height: 34px;
  line-height: 34px;
}
.el-select-dropdown__list li > span {
  float: left;
  margin-left: 20px;
  //   min-width: 150px;
  width: 200px;
  height: 34px;
  line-height: 34px;
}
</style>